module.exports = __webpack_public_path__ + "static/media/store7.b3340238.jpg";